<template>
  <div>
    <v-date-picker
      :min-date='minDate'
      :disabled-dates="disableWeekend ? { weekdays: [1, 7] } : { weekdays: [] }"
      color="green"
      :input="['DD-MM-YYYY', 'DD/MM/YYYY', 'DD.MM.YYYY']"
      :model-config="modelConfig"
      :is-range="range"
      @input="updateDate"
      v-model="dataDate" >
      <template class="input-text d-block" v-slot="{ inputValue, updateValue, showPopover }">
        <div class="ship-date-block calendar-button shadowed" :class="active ? 'active brand' : ''" @click="showPopover">
          <div class="ship-date-block-month">{{ active ? $t('ship_date') : $t('select') }}</div>
          <div class="ship-date-block-date">
            <Icon
            name="calendar"
            size="24"
             /></div>
          <div class="ship-date-block-addition">{{ active ? parseValue(inputValue) : $t('date') }}</div>
        </div>
      </template>
    </v-date-picker>
  </div>
</template>

<script>
/* eslint-disable */
import InputText from "@/components/elements/inputs/text.vue";
import rules from "@/mixins/rules";
import { DateTime } from 'luxon';
import date from "../../../mixins/date";

export default {
  name: "buttonCalendar",
  mixins: [rules, date],
  components: {
    InputText,
  },
  props: {
    value: {
      type: [String, Date, Object],
      default: '',
    },
    date: {
      type: null,
    },
    label: {
      type: String,
      default: "",
    },
    noMinDate: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    noDate: {
      type: Boolean,
      default: false,
    },
    disableWeekend: {
      type: Boolean,
      default: true,
    },
    range: {
      type: Boolean,
      default: false,
    },
    minDateProp: {
      type: [String, Date],
      required: false
    }
  },
  data() {
    return {
      dataDate: this.date,
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
    };
  },
  methods: {
    updateDate(date) {
      this.$emit('date-changed', date)
    },
    parseSingleDate(stringDate) {
      if (stringDate && stringDate !== 'undefined') {
        try {
          return this.parseUnknownDate(stringDate).toFormat(this.defaultDateFormat());
        } catch (e) {
          return '';
        }
      }
      return ''
    },
    parseValue(value) {
      if(!this.range) {
        return this.parseSingleDate(value)
      }
      const formattedDate = []

      if (value.start && value.start !== 'undefined') {
        const startDate = this.parseSingleDate(value.start)
        formattedDate.push(startDate)
      }

      if (value.end && value.end !== 'undefined') {
        const endDate = this.parseSingleDate(value.end)
        formattedDate.push(endDate)
      }

      return formattedDate.join(' - ')
    }
  },
  watch: {
    dataDate: function (newVal, oldVal) {
      this.$emit('input', newVal);
    },
    'date': function () {
      this.dataDate = this.date;
    },
    'value': function (newVal, oldVal) {
      this.dataDate = newVal
    }
  },
  computed: {
    minDate() {
      if (this.minDateProp) {
        return this.minDateProp
      }
      return DateTime.now().setZone(this.userTimezone())
    }
  }
};
</script>
